function Button({ buttonstyle, children }) {
  return <button className={buttonstyle}>{children}</button>;
}

export default Button;
